import React from "react";
import { Space, Tag, Alert, Button } from 'antd';
import { CheckSquareFill, Download } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var AdminAdBox = function AdminAdBox(_ref) {
  var _ref$ad = _ref.ad,
    ad = _ref$ad === void 0 ? null : _ref$ad;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: ad ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [ad.adtype == 'ao' ? /*#__PURE__*/_jsx("h3", {
        className: "highlight",
        children: "Avis d'appel d'offre"
      }) : /*#__PURE__*/_jsx("h3", {
        className: "highlight",
        children: "Appel \xE0 candiature"
      }), /*#__PURE__*/_jsx("h4", {
        children: ad.adlabel
      }), /*#__PURE__*/_jsxs(Space, {
        direction: "vertical",
        children: [/*#__PURE__*/_jsxs(Tag, {
          icon: /*#__PURE__*/_jsx(CheckSquareFill, {}),
          color: "#108ee9",
          children: ["CLIENT : ", ad.enterprise_id == null || ad.enterprise == null ? ad.user.firstname + ' ' + ad.user.lastname : ad.enterprise.companyname, ' ']
        }), /*#__PURE__*/_jsxs(Tag, {
          color: "#87d068",
          children: ["SECTEUR:  ", ad.skill.name]
        })]
      }), /*#__PURE__*/_jsx(Tag, {
        color: "#f50",
        children: "DATE DE CLOTURE : " + new Date(ad.addeadline).toLocaleDateString(undefined, {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        })
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h4", {
          children: "DESCRIPTION DE L'AVIS"
        }), ad.addescription]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          marginTop: '20px',
          padding: '10px',
          background: '#F2F3F4'
        },
        children: [/*#__PURE__*/_jsx("b", {
          children: "Adresse : "
        }), " ", ad.adaddress, " ", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
          children: "Zone : "
        }), " ", ad.adplace]
      }), /*#__PURE__*/_jsxs(Space, {
        direction: "vertical",
        children: [ad.phone && /*#__PURE__*/_jsx(Alert, {
          type: "info",
          message: ad.adphone.slice(3),
          banner: true
        }), " : ", /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx(Alert, {
          type: "info",
          message: ad.ademail,
          banner: true
        }), ": ", /*#__PURE__*/_jsx(_Fragment, {}), ad.adfilepath != null && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Button, {
            href: ad.adfilepath,
            target: "_blank",
            icon: /*#__PURE__*/_jsx(Download, {
              size: 19
            }),
            type: "primary",
            danger: true,
            children: "Fichier avis"
          })]
        })]
      })]
    }) : /*#__PURE__*/_jsx("p", {
      children: "Une erreur est survenue pendant la lecturre"
    })
  });
};
export default AdminAdBox;